import SafeImage from '@ui/SafeImage';
import { prefix } from '@util/imagePrefix';
import UpgradeNowTrigger from 'app/boot-trade-in-program/_components/UpgradeNowTrigger';

type BootTradeInSectionProps = {
  bg?: 'red' | 'white';
};

export const BootTradeInSection = ({ bg = 'red' }: BootTradeInSectionProps) => {
  return (
    <div className="mt-24 flex w-full items-center justify-center px-8 sm:mx-auto sm:mt-32 sm:max-w-[150rem] sm:px-0">
      <div
        className={`relative flex h-[58rem] w-full flex-col rounded-[3rem] ${
          bg === 'red' ? 'bg-[#F9E8E8]' : 'bg-white'
        } sm:h-[50rem] sm:flex-row`}
      >
        <SafeImage
          src={`${prefix}/assets/home-trade-in-floating-boots_1920x2560.png`}
          alt="Boot Trade-In Program"
          className="absolute -top-[8rem] h-[38rem] w-full object-cover sm:-left-32 sm:-top-[15rem] sm:h-[70rem] sm:w-auto"
          height={3840}
          width={7200}
        />

        <div className="absolute top-[13rem] flex h-full w-full items-center justify-center sm:left-[35rem] sm:top-0">
          <div className="flex flex-col gap-y-2">
            <span className="hidden text-[1.8rem] font-semibold text-[#444444] sm:block">
              Boot Trade-In Program
            </span>

            <h3 className="w-full text-center text-[2.5rem] font-bold text-black sm:hidden sm:w-[43rem] sm:text-left sm:text-[3.7rem]">
              Upgrade your boots today!
            </h3>
            <h3 className="hidden w-full text-center text-[2.5rem] font-bold text-black sm:block sm:w-[43rem] sm:text-left sm:text-[3.7rem]">
              Trade in Your Boots & Upgrade for Less!
            </h3>

            <div className="flex flex-col gap-y-6">
              <span className="w-full px-4 text-center text-[1.8rem] font-medium text-[#444444] sm:w-[55rem] sm:px-0 sm:text-left">
                Get credit towards your next pair of boots by trading in your
                old ones. It's easy, fast, and environmentally friendly!
              </span>

              <div className="flex w-full justify-center sm:justify-start">
                <UpgradeNowTrigger title="Start Your Trade-In Now!" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
